import { PAYIN_REQ_RES_LOGS, PAYIN_REQ_RES_STATUS_CHECK } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const PayinReqResLogs = (payload) => {
  return apiInstance.post(PAYIN_REQ_RES_LOGS, payload);
};
export const StatusCheck = (payload) => {
  return apiInstance.post(PAYIN_REQ_RES_STATUS_CHECK, payload);
};
